export const municipalities = state => state.getIn(['municipalities', 'entities']);
export const municipalityById = (state, id) => municipalities(state).get(String(id));
export const municipalitiesByIds = (state, ids) => ids.map(id => municipalityById(state, id));
